export const pinsQueryKeys = {
  GET_PROJECT_PINS: 'getProjectPins'
}
